<!--共用 header-->
<header class="header-container" [class.active]="router.url === '/healthcheck'">
  <!--左側：logo-->
  <div class="header-left-logo" (click)="navigateToHome()"></div>

  <!--右側：menu 功能-->
  <div class="header-right-menu">
    @if (router.url === '/healthcheck') {
      <!--按鈕:Language 語系-->
      @if (translateService.currentLang === LANGS.ZH_TW) {
        <button
          mat-button
          class="header-right-btn-language btn-text btn-size-l"
          (click)="switchLanguage(LANGS.EN_US)"
        >
          <img width="24" height="24" ngSrc="/assets/img/i-globe.svg" alt="" />
          <span class="text-language-en">EN</span>
        </button>
      } @else {
        <button
          mat-button
          class="header-right-btn-language btn-text btn-size-l"
          (click)="switchLanguage(LANGS.ZH_TW)"
        >
          <img width="24" height="24" ngSrc="/assets/img/i-globe.svg" alt="" />
          <span>中文</span>
        </button>
      }
    }

    @if (
      router.url === '/healthcheck' ||
      router.url === '/healthcheck/reserve/complete' ||
      router.url.startsWith('/healthcheck/member')
    ) {
      @if (sharedStorageService.get('loginStatus') === 'memberLogin') {
        <!--按鈕:member 會員中心 登入-->
        <button
          mat-button
          [matMenuTriggerFor]="menu"
          class="header-right-btn-member btn-login-menu btn-fill-secondary btn-size-l"
          (menuOpened)="isMenuOpened = true"
          (menuClosed)="isMenuOpened = false"
        >
          <img
            width="24"
            height="24"
            ngSrc="/assets/img/i-account.svg"
            alt=""
          />
          <span class="text-member">{{
            'header.member-center' | translate
          }}</span>
          <img
            width="24"
            height="24"
            [ngSrc]="
              isMenuOpened
                ? '/assets/img/i-arrow-up.svg'
                : '/assets/img/i-arrow-down.svg'
            "
            alt=""
          />
        </button>
        <mat-menu #menu="matMenu">
          @if (router.url === '/healthcheck'|| router.url === '/healthcheck/reserve/complete'){
            <button mat-menu-item (click)="goToMemberCenter()">
              {{ 'header.member-center' | translate }}
            </button>
            <button mat-menu-item (click)="logOut()">
              {{ 'common.button.logout' | translate }}
            </button>
          }
          @if(router.url.startsWith('/healthcheck/member')) {
            <button mat-menu-item routerLink="/healthcheck/">
            {{ 'header.home' | translate }}
          </button>
          <button mat-menu-item (click)="logOut()">
            {{ 'common.button.logout' | translate }}
          </button>
          }
        </mat-menu>
      } @else {
        <!--按鈕:member 會員中心 未登入-->
        @if (translateService.currentLang === LANGS.ZH_TW) {
          <button
            mat-button
            class="header-right-btn-member btn-fill-secondary btn-size-l"
            routerLink="/healthcheck/login"
          >
            <img
              width="24"
              height="24"
              ngSrc="/assets/img/i-account.svg"
              alt=""
            />
            <span class="text-member">{{
              'header.member-login' | translate
            }}</span>
            <span class="text-login-mobile">{{
              'common.button.login' | translate
            }}</span>
          </button>
        }
      }
    }
  </div>
</header>
<!--btn-test 測試按鈕-->
@if ((env?.environment === 'dev' || env?.environment === 'uat') && healthPlan !== 'special') {
  <div class="btn-test">
    <mat-button-toggle-group
      name="fontStyle"
      aria-label="Font Style"
    >
      <mat-button-toggle (click)="injectDirtyData()">
        測試髒資料
      </mat-button-toggle>

    </mat-button-toggle-group>
  </div>
}


<!--btn-test 測試按鈕-->
<!-- @if (devService.isDev()) {
  <div class="btn-test">
    <mat-button-toggle-group
      name="fontStyle"
      aria-label="Font Style"
      [(ngModel)]="authService.login"
      (change)="toggleLoginStatus($event)"
    >
      <mat-button-toggle [value]="true">已登入</mat-button-toggle>
      <mat-button-toggle [value]="false">未登入</mat-button-toggle>
    </mat-button-toggle-group>
  </div>
} -->
